import { INotificationModel } from "../../../service/notification/INotificationModel";

export enum GPBNotificationEvent {
  GPB_APPLICATION_CHECK = 'GPB_APPLICATION_CHECK',
}

export interface IGpbNotificationModel extends INotificationModel<GPBNotificationEvent> { }
